import React, { useState } from "react";
import { Steps, Step } from "react-step-builder";
import { Formik, Form, useFormikContext } from "formik";
import * as Yup from "yup";
import { DropzoneArea } from "material-ui-dropzone";

import "fontsource-roboto";
import MakeStyleModule from "./EnrolementFormStyle";
import Step1 from "./Steps/Step1/Step1";
import Step2 from "./Steps/Step2/Step2";
import Step3 from "./Steps/Step3/Step3";
import Step4 from "./Steps/Step4/Step4";
import FinalStep from "./Steps/FinalStep/FinalStep";

const EnrolementForm = () => {
  const date = new Date();
  const currentDate = new Date().toISOString().substr(0, 10).toString();
  let endDate = new Date();
  endDate.setDate(date.getDate() + 15);
  endDate = endDate.toISOString().substr(0, 10);

  const useStyle = MakeStyleModule;
  const classes = useStyle();

  /**
   * Valeurs qui évoluent et qui servent de base de vérification à ValidationSchema qui ne peut pas accéder au state de Formik
   */
  const [formState, setFormState] = useState({
    isLimitedTime: false,
    startDate: currentDate,
    endDate: endDate,
    color: "#000",
    chips: [],
    formLastName: false,
    formFirstName: false,
    formGender: false,
    formBirthDate: false,
    formEmail: false,
    formPhone: false,
    formAddress: false,
    formPostalCode: false,
    formCity: false,
    formChallenge: false,
    challengeEntreprise: false,
    challengeClub: false,
    challengeFamille: false,
    otherChallenge: false,
    otherChallengeInput: "",
    registerFormat: "",
    partnerLogos: [],
    scratchRank: false,
    genderRank: false,
    challengesRank: false,
    otherAsk: "",
    name: "",
    isEmail: false,
    isPhone: false,
    email: "",
    phone: "",
  });

  let ValidationSchema = Yup.object().shape({
    appName: Yup.string()
      .max(20, "Doit être de 20 caractères ou moins")
      .min(3, "Doit être de 3  caractères ou plus")
      .required("Veuillez remplir le champ"),

    startDate: Yup.date()
      .nullable()
      .default(undefined)
      .typeError("Please enter a valid Date")
      .max(
        formState.endDate,
        "Veuillez saisir une date de début antérieure à la date de fin"
      )
      .min(
        currentDate,
        "Veuillez saisir une date de début postérieure ou égale à aujourd'hui"
      ),
    endDate: Yup.date()
      .nullable()
      .default(undefined)
      .typeError("Invalid Date")
      .min(
        formState.startDate,
        "Veuillez saisir une date fin postérieure à la date de début"
      )
      .min(
        currentDate,
        "Veuillez saisir une date de début postérieure ou égale à aujourd'hui"
      ),
    appLogo: Yup.array()
      .min(1, "Veuillez choisir un logo d'application")
      .max(1, "Veuillez n'envoyer qu'un seul logo"),
    color: Yup.string().max(7, "7 charactères max"),
    price: Yup.number()
      // .max(8, "8 charactères max")
      .required("Veuillez remplir le champ"),
    typeChallenge: Yup.string().required("Veuillez séléctionner une option"),
    name: Yup.string()
      .max(20, "Doit être de 20 caractères ou moins")
      .min(3, "Doit être de 2 caractères ou plus")
      .required("Veuillez remplir le champ"),
    email: Yup.string().email("Veuillez remplir ce champ avec un email valide"),
    phone: Yup.string()
      .min(10, "Votre numéro de téléphone doit contenir 10 chiffres ou plus")
      .max(16, "Ce n'est pas un numéro de téléphone valide"),
  });

  return (
    <div className={classes.root}>
      <Formik
        initialValues={{
          appName: "",
          startDate: currentDate,
          endDate: endDate,
          appLogo: [],
          color: "",
          price: "",
          typeChallenge: "",
          directors_array: ["director-0"],
          appID: 0,
          gpxTrace: [{ name: "gpxTrace-0", file: [], traceName: "" }],
        }}
        validationSchema={ValidationSchema}>
        {({ errors, touched, setFieldValue, validate }) => (
          <Form>
            <Steps>
              <Step
                touched={touched}
                errors={errors}
                setFieldValue={setFieldValue}
                currentDate={currentDate}
                endDate={endDate}
                component={Step1}
                setFormState={setFormState}
                formState={formState}
              />
              <Step
                errors={errors}
                touched={touched}
                setFormState={setFormState}
                formState={formState}
                component={Step2}
              />
              <Step
                setFieldValue={setFieldValue}
                errors={errors}
                touched={touched}
                component={Step3}
                setFormState={setFormState}
                formState={formState}
              />
              <Step
                setFieldValue={setFieldValue}
                errors={errors}
                touched={touched}
                component={Step4}
                setFormState={setFormState}
                formState={formState}
              />
              <Step
                setFormState={setFormState}
                setFieldValue={setFieldValue}
                formState={formState}
                errors={errors}
                touched={touched}
                component={FinalStep}
              />
            </Steps>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default EnrolementForm;
